var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.831,
    height: 12.223,
    viewBox: "0 0 13.831 12.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M19.25,2.982V5.556a.482.482,0,1,0,.965,0V2.982a.482.482,0,1,0-.965,0Z",
    transform: "translate(-6.42)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M17.732,5.465h2.573a.482.482,0,0,0,0-.965H17.732a.482.482,0,1,0,0,.965Z",
    transform: "translate(-5.707 -0.713)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M9.452,3H6.312A1.126,1.126,0,0,0,5.3,3.622L4.7,4.841a.162.162,0,0,1-.144.089H3.019A1.769,1.769,0,0,0,1.25,6.7v6.433A1.768,1.768,0,0,0,3.019,14.9H13.312a1.768,1.768,0,0,0,1.769-1.769V7.664a.482.482,0,1,0-.965,0v5.468a.8.8,0,0,1-.8.8H3.019a.8.8,0,0,1-.8-.8V6.7a.8.8,0,0,1,.8-.8H4.552a1.126,1.126,0,0,0,1.007-.622l.609-1.219a.162.162,0,0,1,.144-.089H9.452a.482.482,0,1,0,0-.965Z",
    transform: "translate(0 -0.178)",
    fill: "#292828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M10.306,8.5a3.056,3.056,0,1,0,3.056,3.056A3.057,3.057,0,0,0,10.306,8.5Zm0,.965a2.091,2.091,0,1,1-2.091,2.091A2.092,2.092,0,0,1,10.306,9.465Z",
    transform: "translate(-2.14 -2.14)",
    fill: "#292828",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.2a79a4c818ddef458cbb48b36736ab05.svg";
export { ForwardRef as ReactComponent };